import styled from 'styled-components';
import { Box } from '../Box/Box.es.js';

const Center = styled(Box)`
    display: flex;
    width: 100%;
    height: 100%;
    place-items: center;
    place-content: center;
`;

export { Center };
//# sourceMappingURL=styled.es.js.map
